module.exports = __webpack_public_path__ + "img/ax.b10e2392.svg";